export default __webpack_public_path__ + "static/media/Red-icon.32cd414f.svg";